import React from 'react';
import VStack from '../Layout/VStack';
import Box from '../Layout/Box';
import AppText from '../AppText';
import QuestionRenderer from './QuestionRenderer';
import {Colors} from '../../../styles/Colors';
import {GlobalStyleAttributes} from '../../../styles/GlobalStyles';

const QuestionsSection = ({title, questions, errors, onChange, disabled}) => (
    <VStack>
        {title &&
        <Box style={{justifyContent: 'center', paddingTop: '20px', paddingBottom: '16px'}}>
            <Box style={{padding: '4px 12px', borderRadius: '999px', backgroundColor: Colors.newDesign.titleBadgeBg, border: `1px solid ${Colors.newDesign.titleBadgeBorder}`}}>
                <AppText boldFont fontSize={GlobalStyleAttributes.fonts.heading18} style={{textTransform: 'capitalize', letterSpacing: '0.55px'}}>{title}</AppText>
            </Box>
        </Box>}
        {questions.map((question, index) => (
            <QuestionRenderer key={question.id} question={question} error={errors?.[index]?.user_answer ?? errors?.[index]?.checked_array} onChange={(updatedQuestion) => onChange(index, updatedQuestion)} disabled={disabled} />
        ))}
    </VStack>
);

export default QuestionsSection;
